'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _WidgetMessage2 = require('./WidgetMessage');

var _WidgetMessage3 = _interopRequireDefault(_WidgetMessage2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Representation of a response message
 *
 * @class
 * @extends {WidgetMessage}
 */
var WidgetResponse = function (_WidgetMessage) {
  (0, _inherits3.default)(WidgetResponse, _WidgetMessage);
  (0, _createClass3.default)(WidgetResponse, null, [{
    key: 'parse',

    /**
     * Parse an object literal or a JSON encoded string into a {@link WidgetResponse}
     *
     * @static
     * @method
     *
     * @param {{}|string} raw
     * @return {WidgetResponse}
     */
    value: function parse(raw) {
      var id = raw.id,
          widgetId = raw.widgetId,
          correlationId = raw.correlationId,
          body = raw.body,
          status = raw.status;
      // still receiving json encoded strings as body from success responses

      var parsedBody = typeof body === 'string' ? JSON.parse(body) : body;
      return new WidgetResponse({ id: id, widgetId: widgetId, correlationId: correlationId.toString(), body: parsedBody, status: status });
    }
  }]);

  /**
   * @param {String} id the message id
   * @param {String} widgetId the widget it
   * @param {String} correlationId the conversation id
   * @param {*} body the message body
   * @param {String} status the response status
   */
  function WidgetResponse(_ref) {
    var id = _ref.id,
        widgetId = _ref.widgetId,
        correlationId = _ref.correlationId,
        body = _ref.body,
        status = _ref.status;
    (0, _classCallCheck3.default)(this, WidgetResponse);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetResponse.__proto__ || (0, _getPrototypeOf2.default)(WidgetResponse)).call(this, { id: id, widgetId: widgetId, correlationId: correlationId, body: body, status: status }));
  }

  /**
   * @readonly
   *
   * @type {String}
   */


  (0, _createClass3.default)(WidgetResponse, [{
    key: 'status',
    get: function get() {
      return this.props.status;
    }
  }, {
    key: 'rawBody',


    /**
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }, {
    key: 'body',


    /**
     * @readonly
     *
     * @type {*}
     */
    get: function get() {
      return this.props.body;
    }
  }]);
  return WidgetResponse;
}(_WidgetMessage3.default);

exports.default = WidgetResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/WidgetResponse.js
// module id = 99
// module chunks = 0